import React, { memo, useContext, BaseSyntheticEvent, forwardRef, useEffect, useState } from 'react'

import { clsx } from 'clsx'
import { useWatch } from 'react-hook-form'

import { AppContext, railsContext } from 'Const'
import { PaymentMethods } from 'Types'

import { StepContext } from '..'
import { usePayment } from '../PaymentArea/Provider'

import Arrow from './Arrow.svg'
import SquareBtn from './SquareBtn'
import StripeBtn from './StripeBtn'

interface Props {
  disabled?: boolean
  loading?: boolean
  onSubmit: (e?: BaseSyntheticEvent) => void
}
const NextStepBtn = forwardRef<HTMLButtonElement, Props>(({ onSubmit, loading, disabled }, ref) => {
  const { isLastStep } = useContext(StepContext)
  const { cart } = useContext(AppContext)
  const { gateway } = usePayment()
  const { field } = gateway
  const paymentMethod = useWatch({ name: `${field}.paymentMethod` })
  const hasPayment = !!gateway.name

  disabled = disabled || loading

  const [serverSideDisabled, setServerSideDisabled] = useState(true)

  // NOTE: useEffect to prevent hydration issue
  useEffect(() => {
    if (!railsContext.serverSide) setServerSideDisabled(false)
  }, [])

  const label = isLastStep ? (hasPayment ? `Pay now ${cart.totalMoneyFormatted}` : 'Order now') : 'Continue'

  return (
    <div className="d-flex / justify-content-end / mt-4">
      <div className="checkout-step__next-step-button-wrapper">
        {!hasPayment || !paymentMethod || paymentMethod === PaymentMethods.CARD ? (
          <button
            ref={ref}
            aria-label={label}
            className={clsx(
              'checkout-step__next-step-button / btn btn-accent / d-flex align-items-center justify-content-center',
              { btn_loading: loading },
            )}
            disabled={serverSideDisabled || disabled}
            type="submit"
            onClick={onSubmit}
          >
            <span>{label}</span>
            {isLastStep ? null : <Arrow className="sociavore-icon sociavore-icon--fill / ml-auto" />}
          </button>
        ) : null}
        {gateway.isStripe ? (
          <StripeBtn onSubmit={onSubmit} />
        ) : gateway.isSquare ? (
          <SquareBtn disabled={disabled} />
        ) : null}
      </div>
    </div>
  )
})

NextStepBtn.displayName = 'NextStepBtn'

export default memo(NextStepBtn)
